import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import HandleTable from "./HandleTable";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { resumeRequest, TokenSubData } from "../TokenProcessing";
import { SubdataProps } from "../../Editor/EditorComponents/ModalButton";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
      Title?: string;
      ViewIdent?: string;
    };
    CLSID?: string;
    Module?: string;
    Title?: string;
    DlgType?: string;
    content?: unknown;
  };
  subData: { props: SubdataProps } & TokenSubData;
  requestID: string;
}

export const defaultHandleTable = (data: Data) => {
  const { json, subData, requestID } = data;

  smetaModals.open(
    <HandleTable
      json={json}
      subData={{
        props: {
          ...subData.props,
          SectionID: getModalSectionID(),
          func: subData.func,
          from: subData.from,
        },
      }}
    />,
    {
      Title: json.Title,
      style: getStyleWindow(json.CLSID || json.DlgType),
      onClose: () => {
        subData?.props?.onClose?.();
        subData.props?.input?.current?.focus();
        resumeRequest(requestID, subData, {});
      },
      callBacks: true,
    },
  );
};
